import { useEffect } from 'react';

export const usePageTitle = (pageTitle: string) => {
  useEffect(() => {
    const baseTitle = 'REC-CRM';
    const newTitle = pageTitle ? `${baseTitle} / ${pageTitle}` : baseTitle;
    
    console.log('usePageTitle called:', { pageTitle, newTitle });
    console.log('Current document.title before:', document.title);
    
    // Forcer la mise à jour du titre immédiatement
    document.title = newTitle;
    console.log('Title set immediately to:', document.title);
    
    // Vérifier après un délai
    setTimeout(() => {
      console.log('Title after 500ms:', document.title);
      if (document.title !== newTitle) {
        console.log('Title was changed by something else, forcing update...');
        document.title = newTitle;
      }
    }, 500);
    
    // Restaurer le titre par défaut quand le composant se démonte
    return () => {
      console.log('usePageTitle cleanup:', { baseTitle });
      document.title = baseTitle;
    };
  }, [pageTitle]);
}; 